import React from 'react'

function Blogdetails() {
  return (
 <div><main className="page-content">
    <div className="tm-section tm-blog-details-page tm-padding-section bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-12">
            <div className="tm-blog blogitem">
              <div className="col-lg-4 tm-blog-topside">
                <div className="tm-blog-thumb">
                  <img src="assets/images/blog/blog-image-1-lg.jpg" alt="blog image" />
                </div>
                <span className="tm-blog-metahighlight">April 30, 2024</span>
              </div>
              <div className="tm-blog-content">
                <h6 className="tm-blog-title"><a href="blog-details.html">Woman wearing
                    gold-colore ring
                    pendant necklaces</a></h6>
                <ul className="tm-blog-meta">
                  <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                  <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                </ul>
                <p>Lorem ipsum dolor sit amet,consectetur adipiscing elit. Quisque mi dolor,
                  malesuada id metus a, mattis eleifend elit. Nullam pharetra consequat ex in
                  dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
                  posuere cubilia Curae; Vivamus lacinia dui tellus. Donec condimentum vel diam
                  egetac cumsan. Fusce sit amet nunc fermentum, mattis lacus eu, euismod ipsum.
                  Nam tincidunt leo sed lorem ultricies molestie. In in turpis id risus lacinia
                  finibus eget eget eros. Mauris lobortis, tortor eu ornare conva mauris tortor
                  blandit orci, nec eleifend velit dolor sit amet nunc.Suspendisse vel ipsum
                  tempor, volutpat arcuat, faucibus mi. In efficitur lorem mattis diam finibus
                  finibus.</p>
                <blockquote>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi odit
                    libero velit, nostrum at nihil deleniti doloribus assumenda optio.</p>
                </blockquote>
                <p>Nunc tincidunt id eros non euismod. Sed tellus erat, varius et sollicitudin non,
                  ullamcorper eget arcu. Mauris at lectus aliquet, vestibulum dui non, volutpat
                  orci. Integer dapibus tincidunt ornare. Praesent blandit leo at turpis porta, a
                  dignissim nunc consequat. Etiam eu varius enim, et varius lacus. Integer tellus
                  tellus, dictum ac pellentesque quis,scelerisque at ligula. Maecenas dignissim
                  lectus a mauris vulpu
                  suspendisse potenti. Duis id cursusaugue, vitae scelerisque metus. </p>
              </div>
              <div className="blogitem-share">
                <h6 className="blogitem-share-title">Share With: </h6>
                <ul>
                  <li className="facebook"><a href="https://www.facebook.com/sharer/sharer.php?u="><i className="ion-social-facebook" /> Facebook</a></li>
                  <li className="twitter"><a href="https://twitter.com/home?status="><i className="ion-social-twitter" />
                      Twitter</a></li>
                  <li className="pinterest"><a href="https://pinterest.com/pin/create/button/?url=&media=&description="><i className="ion-social-pinterest-outline" /> Pinterest</a></li>
                  <li className="linkedin"><a href="https://www.linkedin.com/shareArticle?mini=true&url=&title=&summary=&source="><i className="ion-social-linkedin-outline" /> Linkedin</a></li>
                </ul>
              </div>
              <div className="blogitem-comments">
                <h5 className="small-title">Comments (3)</h5>
                <div className="tm-comment-wrapper mt-30">
                  <div className="tm-comment">
                    <a href="blog.html" className="tm-comment-thumb">
                      <img src="assets/images/author-image-1.jpg" alt="author image" />
                    </a>
                    <div className="tm-comment-content">
                      <h6 className="tm-comment-authorname"><a href="blog.html">Dorris
                          Goyette</a></h6>
                      <span className="tm-comment-date">Wednesday, October 17, 2023 at
                        4:00PM.</span>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                        sed do
                        eiusmod
                        tempor incididunt ut labore dolore magna aliqua. Ut enim ad
                        minim
                        veniam.</p>
                      <a href="#" className="tm-comment-replybutton"><i className="ion-reply-all" />
                        Reply</a>
                    </div>
                  </div>
                  <div className="tm-comment tm-comment-replypost">
                    <a href="blog.html" className="tm-comment-thumb">
                      <img src="assets/images/author-image-2.jpg" alt="author image" />
                    </a>
                    <div className="tm-comment-content">
                      <h6 className="tm-comment-authorname"><a href="blog.html">Gladys
                          Zulauf</a></h6>
                      <span className="tm-comment-date">Wednesday, October 17, 2023 at
                        4:00PM.</span>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                        sed do
                        eiusmod
                        tempor dolore magna aliqua. Ut enim ad minim
                        veniam.</p>
                      <a href="#" className="tm-comment-replybutton"><i className="ion-reply-all" />
                        Reply</a>
                    </div>
                  </div>
                  <div className="tm-comment">
                    <a href="blog.html" className="tm-comment-thumb">
                      <img src="assets/images/author-image-3.jpg" alt="author image" />
                    </a>
                    <div className="tm-comment-content">
                      <h6 className="tm-comment-authorname"><a href="blog.html">Kareem
                          Todd</a></h6>
                      <span className="tm-comment-date">Wednesday, October 17, 2023 at
                        4:00PM.</span>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                        sed do
                        eiusmod
                        tempor incididunt ut labore dolore magna aliqua. Ut enim ad
                        minim
                        veniam.</p>
                      <a href="#" className="tm-comment-replybutton"><i className="ion-reply-all" />
                        Reply</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="blogitem-commentbox mt-30">
                <h5 className="small-title">Leave a Comment </h5>
                <p>Your email address will not be published. Required fields are
                  marked *</p>
                <form action="#" className="tm-form mt-30">
                  <div className="tm-form-inner">
                    <div className="tm-form-field tm-form-fieldhalf">
                      <input type="text" id="tm-comment-namefield" placeholder="Name*" />
                      <span className="tm-form-animatedline" />
                    </div>
                    <div className="tm-form-field tm-form-fieldhalf">
                      <input type="email" id="tm-comment-email" placeholder="Email*" />
                      <span className="tm-form-animatedline" />
                    </div>
                    <div className="tm-form-field">
                      <input type="text" id="tm-comment-website" placeholder="Website" />
                      <span className="tm-form-animatedline" />
                    </div>
                    <div className="tm-form-field">
                      <textarea name="tm-comment-textbox" id="tm-comment-textbox" cols={30} rows={7} placeholder="Enter your comment" defaultValue={""} />
                      <span className="tm-form-animatedline" />
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button tm-button-dark">Post
                        Comment</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* <div class="col-lg-4 col-12">
              <div class="widgets widgets-one widgets-sidebar">
                  <div class="single-widget widget-search">
                      <h6 class="widget-title">Search</h6>
                      <form action="#" class="widget-search-form">
                          <input type="text" placeholder="Enter your keyword...">
                          <button type="submit"><i class="ti ti-search"></i></button>
                      </form>
                  </div>
                  <div class="single-widget widget-categories">
                      <h6 class="widget-title">Categories</h6>
                      <ul>
                          <li><a href="blog.html">Wedding Jewelry</a></li>
                          <li><a href="blog.html">Rings</a></li>
                          <li><a href="blog.html">Earrings</a></li>
                          <li><a href="blog.html">Bracelets</a></li>
                          <li><a href="blog.html">Nacklaces</a></li>
                          <li><a href="blog.html">Children’s Jewelry</a></li>
                          <li><a href="blog.html">Expression Jewelry</a></li>
                      </ul>
                  </div>
                  <div class="single-widget widget-recentpost">
                      <h6 class="widget-title">Recent Posts</h6>
                      <ul>
                          <li>
                              <a href="blog-details.html" class="widget-recentpost-image">
                                  <img src="assets/images/blog/blog-thumbnail-1.jpg" alt="blog thumbnail">
                              </a>
                              <div class="widget-recentpost-content">
                                  <h6><a href="blog-details.html">Diamond Ring</a></h6>
                                  <span>January 15, 2024</span>
                              </div>
                          </li>
                          <li>
                              <a href="blog-details.html" class="widget-recentpost-image">
                                  <img src="assets/images/blog/blog-thumbnail-2.jpg" alt="blog thumbnail">
                              </a>
                              <div class="widget-recentpost-content">
                                  <h6><a href="blog-details.html">Couple Ring</a></h6>
                                  <span>Janury 14, 2024</span>
                              </div>
                          </li>
                          <li>
                              <a href="blog-details.html" class="widget-recentpost-image">
                                  <img src="assets/images/blog/blog-thumbnail-3.jpg" alt="blog thumbnail">
                              </a>
                              <div class="widget-recentpost-content">
                                  <h6><a href="#blog-details.html">Diamon Bracelets</a></h6>
                                  <span>January 13, 2024</span>
                              </div>
                          </li>
                      </ul>
                  </div>
                  <div class="single-widget widget-archives">
                      <h6 class="widget-title">Archives</h6>
                      <ul>
                          <li><a href="#">December 2023</a></li>
                          <li><a href="#">Septemper 2023</a></li>
                          <li><a href="#">June 2023</a></li>
                          <li><a href="#">April 2023</a></li>
                          <li><a href="#">February 2024</a></li>
                          <li><a href="#">January 2024</a></li>
                      </ul>
                  </div>
                  <div class="single-widget widget-tags">
                      <h6 class="widget-title">Popular Tags</h6>
                      <ul>
                          <li><a href="products.html">Rings</a></li>
                          <li><a href="products.html">Earring</a></li>
                          <li><a href="products.html">Pandants</a></li>
                          <li><a href="products.html">Sets</a></li>
                          <li><a href="products.html">Bangles</a></li>
                          <li><a href="products.html">Rings</a></li>
                          <li><a href="products.html">Earring</a></li>
                          <li><a href="products.html">Pandants</a></li>
                      </ul>
                  </div>
              </div>
          </div> */}
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Blogdetails